export default __webpack_public_path__ + "static/media/insta-2.a1786efa.jpg";